import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },

  bgLinearGradient: {
    width: "100%",
    alignItems: "center",
    flex: 1,
  },

  btnTipoConta: {
    backgroundColor: "#fff",
  },

  header: {
    backgroundColor: "#2C2C2E",
    height: 90,
    paddingHorizontal: 25,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottomColor: "#196059",
    borderBottomWidth: 2,
  },
  text1: {
    color: "#fff",
  },
  title: {
    color: "#fff",
    fontSize: 16,
  },
  actionContainer: {
    color: "#fff",
    flex: 1,
    position: "relative",
    marginTop: "auto",
    alignItems: "center",
  },
  button: {
    marginTop: 12,
    padding: 10,
    width: 320,
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    position: "relative",
  },
  buttonTexto: {
    Color: "#000",
    fontsize: 24,
    fontWeight: "600",
    lineheight: 15.538,
  },
  buttonAcao: {
    Color: "#fff",
    fontsize: 50,
  },
  icon: {
    width: 20,
  },
  form: {
    justifyContent: "center",
    marginTop: 100,
    flex: 1,
  },
  formGeral: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    marginTop: 100,
  },
  pj: {
    backgroundColor: "#fff",
    marginTop: 40,
    marginBottom: 20,
  },
  label: {
    fontSize: 1,
    width: 20,
    height: 48,
  },
  geral: {
    color: "#000",
  },
  error: {
    fontSize: 17,
    color: "#000",
    fontStyle: "italic",
    marginTop: 10,
  },
  containerSocialContract: {
    paddingRight: 25,
    marginTop: 20,
  },
  description: {
    textAlign: "justify",
    fontSize: 14,
    fontWeight: "400",
    lineHeight: 15,
  },
  btnAdd: {
    height: 40,
    width: "100%",
    borderColor: "#196059",
    borderWidth: 2,
    borderRadius: 20,
    marginTop: 20,
  },
  iconAdd: {
    textAlign: "center",
    marginTop: 5,
  },
  image: {
    width: 150,
    height: 150,
    flexshrink: 0,
    marginTop: 200,
  },
  image2: {
    width: 150,
    height: 150,
    marginTop: 120,
  },

  textButtonContinuar: {
    color: "#fff",
    textTransform: "uppercase",
  },

  btnVoltarText: {
    color: "#077A97",
    textTransform: "uppercase",
  },

  btnVoltar: {
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#FFF",
    marginVertical: 12,
    alignSelf: "center",
    color: "#077A97",
  },

  btnPais: {
    backgroundColor: "#FFFFFF",
    color: "077A97",
    padding: 10,
    width: 320,
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
  },
});

export default styles;
